/**
 * Pure mutation functions for permission and role actions.
 */

import {ANON_ROLE_UID} from "@buildwithflux/constants";
import type {DocumentPermissionsData, IDocumentData, IProjectInviteData, PermissionType} from "@buildwithflux/models";
import {generateUserAccessListForDocument} from "@buildwithflux/models";

import Document from "modules/storage_engine/helpers/Document";

export function applySetRole(draft: IDocumentData, role: DocumentPermissionsData): void {
    Document.setUserPermissions(draft, role);
}

export function applyRemoveRole(draft: IDocumentData, roleUid: string): void {
    Document.removeUserPermissions(draft, roleUid);
}

export function applySetProjectInvite(draft: IDocumentData, invite: IProjectInviteData): void {
    draft.invites[invite.uid] = invite;
}

export function applyRemoveProjectInvite(draft: IDocumentData, invite: IProjectInviteData): void {
    delete draft.invites[invite.uid];
}

export function applySetDocumentAsPrivate(draft: IDocumentData): void {
    Document.setPermissionsToPrivate(draft);
}

export function applySetEnterpriseMemberPermissionType(draft: IDocumentData, permissionType: PermissionType): void {
    draft.enterprise_member_permission_type = permissionType;
    draft.user_access_list = generateUserAccessListForDocument(draft, Object.values(draft.roles));
    draft.has_anon_access = draft.user_access_list.includes(ANON_ROLE_UID);
}

export function applySetOrganizationMemberPermissionType(draft: IDocumentData, permissionType: PermissionType): void {
    draft.organization_member_permission_type = permissionType;
    draft.user_access_list = generateUserAccessListForDocument(draft, Object.values(draft.roles));
    draft.has_anon_access = draft.user_access_list.includes(ANON_ROLE_UID);
}
